import { Button } from "antd";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { bailiffDocumentDetailSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const PaymentDetail = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(bailiffDocumentDetailSelector);
  const id = detail?.id;
  const href = `/bailiff/${id}`;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Button href={href} type="primary" size="large">
      Xem Chi Tiết
    </Button>
  );
};
export default PaymentDetail;
